<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Sobre a São Pedro Imóveis';
</script>

<PageHeader title={titlePage} type={1}>
	<span slot="content">
		<h2 class="color-secondary">"Zelar pelo seu patrimônio é a nossa missão"</h2>
	</span>
</PageHeader>

<div class="container">

	<span class="float-sm-left mr-40 mb-40" style="width: 535px; text-align: center; padding-bottom: 20px;">
		<div>
			<picture class="image-gallery float-sm-left" style="display: flex;">
				<img class="img-fluid" src="assets/images/fachada.jpg" alt="Sede da imobiliária">
			</picture>
		</div>
	</span>

	<p>Atuando no mercado imobiliario de Porto Alegre desde 2005, a São Pedro Imóveis possui larga experiência na administração de condomínios, aluguéis, compra e venda de imóveis, buscando sempre inovar e aprimorar o atendimento dos seus clientes.</p>

	<p>Entre em contato conosco ou venha nos fazer uma visita, estamos prontos para atender!</p>

	<hr>
	<div class="button mt-40 text-center">        
		<a href="/contato" use:link replace title="" class="btn btn-secondary">
			FALE CONOSCO <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>

	<br /><br /><br />

</div>